import { Button } from "react-bootstrap";
import { CartPlus, FiletypeCsv, Plus, PlusCircle, PlusLg, Search, Trash } from "react-bootstrap-icons";
import { arrayToCSV, downloadBlobToNewWindow, emptyArray, formatFilename, getRandomId, openLinkExternal, useForceRender } from "../util/utils";
import { InspectionPart } from "../models/InspectionPart";
import { useRef, useState } from "react";
import { SimpleFormField } from "../components/SimpleFormField";
import { BindableFormCheck } from "../components/BindableFormCheck";
import { useProfile } from "../components/ProfileContext";
import { Api } from "../util/Api";

export function PartsForm(props) {
	let { inspection, survey, job, readOnly, saveAction, onChange, ...passableProps } = props;
	let [parts, setParts] = useState(inspection.inspectionParts);
	let [profile] = useProfile();

	let failedQs = (survey?.surveyQuestions || []).concat(job?.jobQuestions || []).map(qmeta => {
		return {
			qmeta: qmeta,
			response: inspection.getResponseFor(qmeta.questionId)
		};
	}).filter(qdata => qdata.response.value == "FAIL");

	let addPartAction = () => {
		let newPart = new InspectionPart();
		newPart.id = getRandomId();
		let newPartsArray = [newPart].concat(inspection.inspectionParts)
		inspection.inspectionParts = newPartsArray;
		setParts(newPartsArray);
	};

	let deleteAction = (part) => () => {
		if(!confirm("Are you sure you want to delete this part?")) {
			return;
		}

		let newPartsArray = inspection.inspectionParts.filter(x => x != part);
		inspection.inspectionParts = newPartsArray;
		setParts(newPartsArray);
	};

	let csvExportAction = () => {
		let data = [["Asset", "Model", "Part", "Part #", "Replaced", "Ordered"]];
		parts.forEach(part => {
			let row = [
				inspection.componentAssetNumber,
				inspection.componentModelNumber,
				part.name,
				part.partNumber,
				part.replaced ? "Y" : "N",
				part.ordered ? "Y" : "N"
			];
			data.push(row);
		});
		
		let csvData = arrayToCSV(data);
		let csvBlob = new Blob([csvData], {type:"text/csv"});
		downloadBlobToNewWindow(csvBlob, formatFilename("csv", profile.dateFormatter(new Date()), inspection.componentAssetNumber, "parts"));
	};
	
	return <div {...passableProps}>
		{failedQs.length != 0 && <div>
			<p>
				The following checks failed: {failedQs.map(qdata => qdata.qmeta.question.name).join(", ")}
			</p>
		</div>}

		{!readOnly && <Button onClick={addPartAction}>Add Part</Button>}
		{parts.length > 0 && <Button onClick={csvExportAction} className="mx-4 filetypeButton"><FiletypeCsv className="filetypeIcon" /></Button>}

		<fieldset disabled={readOnly}>
			<div className="table-responsive" {...passableProps}>			
				<table className="table">
					<thead>
						<tr>
							<th>Part Number</th>
							<th>Part Name</th>
							<th>Notes</th>
							<th>Replaced?</th>
							<th>Ordered?</th>
							<th></th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{parts.map(part => <PartRow key={part.id} inspection={inspection} part={part} deleteAction={deleteAction(part)} onChange={onChange}/>)}
						{parts.length == 0 && <tr><td colSpan={5}>No parts needed.</td></tr>}
					</tbody>
				</table>
			</div>
		</fieldset>
	</div>;
}

function PartRow(props) {
	let partNameInputRef = useRef();
	let { inspection, part, deleteAction, onChange } = props;
	let showPartsFinderAction = async () => {
		let url = await part.buildPartsFinderUrl(inspection);
		openLinkExternal(url);
	};
	let lookupPartNumber = async () => {
		if(navigator.onLine) {
			if(!part.name && (!!part.partNumber)) {
				let partData = await Api.dataForPart(part.partNumber);
				if(!!partData?.description) {
					part.name = partData?.description;
					partNameInputRef.current.value = part.name;
				}
			}	
		}
	}

	return <tr>
		<td><SimpleFormField label={null} bindObject={part} bindAttribute="partNumber" onBlur={lookupPartNumber} onChange={onChange}/></td>
		<td><SimpleFormField label={null} bindObject={part} bindAttribute="name" onChange={onChange} inputRef={partNameInputRef} /></td>
		<td><SimpleFormField label={null} bindObject={part} bindAttribute="notes" onChange={onChange}/></td>
		<td><BindableFormCheck bindObject={part} bindAttribute="replaced" onChange={onChange}/></td>
		<td><BindableFormCheck bindObject={part} bindAttribute="ordered" onChange={onChange}/></td>
		<td>
			<Button onClick={showPartsFinderAction} onChange={onChange}><Search /></Button>
		</td>
		<td>			
			<Button onClick={deleteAction} variant="danger" onChange={onChange}><Trash /></Button>
		</td>
	</tr>
}